<template>
  <div>
    <v-list class="row" three-line>
      <template v-for="item in list">
        <v-list-item v-ripple :key="item.id" :to="'/detail/' + item.uuid">
          <font-avatar :name="item.name"></font-avatar>
          <v-list-item-content>
            <v-list-item-title
              class="d-flex align-center justify-space-between"
            >
              <span>
                {{ item.name }}
                <level-chip :level="item.level"></level-chip>
              </span>
              <span class="text--disabled caption">
                {{ item.time }}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle>{{ item.info }}</v-list-item-subtitle>

            <template v-if="item.photos && item.photos.length !== 1">
              <v-row no-gutters>
                <v-col
                  class="mt-2"
                  cols="6"
                  md="4"
                  lg="3"
                  v-for="n in 2"
                  :key="n"
                  style="padding: 2px"
                >
                  <v-card class="d-flex" tile outlined>
                    <v-img
                      :aspect-ratio="1 / 1"
                      :src="'https://' + item.photos[n - 1]"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="item.name"></v-divider>
      </template>
      <v-list-item class="d-flex justify-center">
        <v-list-item-action>
          <v-btn
            :disabled="btnActive"
            @click="load()"
            min-width="300"
            text
            color="primray"
            >{{ btn }}</v-btn
          >
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import list from "@/networker/list";
import LevelChip from "@/components/common/LevelChip/levelChip";
import FontAvatar from "@/components/common/FontAvatar/fontAvatar";
import aes from "@/tools/aes";
import EventBus from "@/tools/event-bus";
export default {
  components: {
    LevelChip,
    FontAvatar
  },
  data() {
    return {
      page: 1,
      count: 10,
      btn: "加载更多",
      btnActive: false,
      list: []
    };
  },
  methods: {
    encrypt: function(text) {
      return aes.encrypt(text);
    },
    load: function() {
      this.btn = "加载中";
      this.btnActive = true;
      list
        .public(this.count, this.page)
        .then(res => {
          this.btn = "加载更多";
          this.btnActive = false;
          if (res.data.success == true) {
            
            let list = res.data.data.piece;
            if (list.length === 0) {
              this.btn = "木有了，zZZ";
            }
            this.page++;
            this.list.push(...list);
          }
        })
        .catch(() => {
          this.btn = "加载更多";
          this.btnActive = false;
        });
    }
  },
  created() {
    this.load();
     EventBus.$on("listDelete", id => {
      this.list.forEach((val, key) => {
        if (val.uuid === id) {
          this.list.splice(key, 1);
        }
      });
     });
  }
};
</script>

<style></style>
